import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LayoutComponent } from './layouts/layout.component';
import { PageNotFoundComponent } from './shared/404/page-not-found/page-not-found.component';
import { LoginGuard } from './core/guards/login-guard';
import { WhitelabelDetailsGuard } from './core/guards/whitelabel-details.guard';
const routes: Routes = [
  // { path: '', redirectTo: '' ,pathMatch:'full'},
  // Agent sign-in page (signed-in users are sent on to the portal by LoginGuard).
  { path: 'login', canActivate: [LoginGuard, WhitelabelDetailsGuard], loadComponent: () => import('./home-page/biyaheko-login/biyaheko-login.component').then(m => m.BiyahekoLoginComponent) },
  // Register page lives at /signup (its default child in the auth module).
  { path: 'signup', canActivate: [WhitelabelDetailsGuard], loadChildren: () => import('./account/auth/auth.module').then(m => m.AuthModule) },
  { path: '', component: LayoutComponent, loadChildren: () => import('./pages/pages.module').then(m => m.PagesModule) },
  { path: 'home', loadChildren: () => import('./home-page/home-page.module').then(m=>m.HomePageModule)},
  // Old URL: /home-page/... -> /home/... (rest of the path is kept)
  { path: 'home-page', redirectTo: 'home' },
  { path: 'account', canActivate: [WhitelabelDetailsGuard], loadChildren: () => import('./account/account.module').then(m => m.AccountModule)},
  // Shown when the whitelabel details call fails (WhitelabelDetailsGuard).
  { path: 'site-unavailable', loadComponent: () => import('./shared/site-unavailable/site-unavailable.component').then(m => m.SiteUnavailableComponent) },
  { path: '**', component: PageNotFoundComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: 'top' })],
  exports: [RouterModule]
})

export class AppRoutingModule { }
